module.exports = __webpack_public_path__ + "static/media/uniform-google-play.180a75d9.png";